<template>
  <div class="mobileUpload">

    <!-- 给手机上传问题产品图片用 -->
    <div class="head">
      <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :before-upload="befoUpload"
        :on-success="successup" :http-request="httpup" multiple :limit="4" :on-exceed="exceed" :show-file-list="false"
        accept=".jpg,.jpeg,.png">
        <el-button size="small" type="primary" class="primary">上传图片</el-button>
      </el-upload>
      <el-button type="primary" size="small" @click="setMobileUploadImage"> 提交</el-button>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <img :src="item" alt="">
        <div class="btn">
          <!-- <p><el-button size="mini" type="success">更改</el-button></p> -->
          <p> <el-button size="mini" type="success" class="dark" @click="delItem(index)">删除</el-button></p>
        </div>
      </div>
      <!-- 进图条 -->
      <el-progress :percentage="schedule" v-if="schedule != 100" type="circle"></el-progress>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      schedule: (state) => state.schedule,
    })
  },
  data() {
    return {
      list: []
    };
  },
  created() {


  },
  methods: {
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.successup(data.data)
    },
    // 图片上传成功事件
    successup(data) {
      if (this.list.length > 4) return this.$alert('最多只能传4张问题产品图', '提示', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {

        }
      });
      if (data != undefined) {
        this.list.push(data)
      }

      // console.log(this.list);
      this.$forceUpdate()

    },
    befoUpload(file) {

      // const isJPG =
      //   ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      // if (!isJPG) {
      //   if (file.name.indexOf('HEIC') == -1) {
      //     this.$message.error("请上传图片");
      //     return isJPG;
      //   }

      // }

      this.pageLoading = true;
    },
    //删除
    delItem(i) {
      this.list.splice(i, 1)
      this.$forceUpdate()
    },
    // 最多四张
    exceed() {
      this.$alert('最多只能传4张问题产品图', '提示', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {

        }
      });
    },
    //保存上传的图片地址
    setMobileUploadImage() {
      if (this.list == false) return this.$message.error('未上传图片')
      let datas = {
        code: this.$route.query.code,
        images: this.list
      }
      this.$api.problemApi.setMobileUploadImage(datas).then(res => {
        this.list = []
        this.$alert('已上传，请手动退出', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: action => {

          }
        });
      })
    },
    // 随机三位数
    mathNum() {
      var num = '';
      for (var i = 0; i < 3; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num
    }


  }
}
</script>
<style lang='scss' scoped>
.mobileUpload {
  position: relative;
}



.head {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
}

.list {
  padding: 20px;

  .item {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    position: relative;
    margin-bottom: 20px;

    img {
      width: 60%;
    }

    .btn {
      position: absolute;
      bottom: 10px;
      right: 10px;

      p {
        margin-top: 10px;
      }
    }
  }
}
</style>